<template>
  <section
    id="overview"
    class="pdp-overview-container"
  >
    <h3 class="pdp-section-header font-weight-bold">
      Overview
    </h3>
    <div ref="overviewTop">
      <ProductsOverviewMedia :slug="deal.slug" :media="deal.overview_media" />
    </div>
  </section>
</template>

<script>
import ProductsOverviewMedia from './ProductsOverviewMedia.vue';

export default {
  components: {
    ProductsOverviewMedia,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
  /* TODO -- Remove once this is a global style */
  @import '~/styles/dorado/main';

  .title:not([class*='display-']) {
    font-size: 28px;
    font-weight: 600 !important;
    line-height: 42px;
    margin-bottom: 24px;
  }

  @include media-breakpoint-up(lg) {
    .title:not([class*='display-']) {
      font-weight: 700 !important;
    }
  }
</style>
